import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

export interface BusinessArea {
  id: number
  province: string
  region: string
}

interface BusinessAreasState {
  areas: BusinessArea[]
}

const initialState: BusinessAreasState = {
  areas: [{ id: 1, province: "", region: "" }],
}

const businessAreasSlice = createSlice({
  name: "businessAreas",
  initialState,
  reducers: {
    addBusinessArea: (state) => {
      if (state.areas.length < 2) {
        state.areas.push({ id: Date.now(), province: "", region: "" })
      }
    },
    removeBusinessArea: (state, action: PayloadAction<number>) => {
      if (state.areas.length > 1) {
        state.areas = state.areas.filter((area) => area.id !== action.payload)
      }
    },
    updateBusinessArea: (state, action: PayloadAction<BusinessArea>) => {
      const index = state.areas.findIndex((area) => area.id === action.payload.id)
      if (index !== -1) {
        state.areas[index] = action.payload
      }
    },
    resetBusinessAreas: (state) => {
      state.areas = initialState.areas
    },
    setEditedBusinessArea: (state, action) => {
      state.areas = action.payload || initialState.areas;
    }
  },
})

export const { addBusinessArea, removeBusinessArea, updateBusinessArea, resetBusinessAreas, setEditedBusinessArea } = businessAreasSlice.actions
export default businessAreasSlice.reducer
